function isNotNull(thing) {
  return !thing
}

export function requiredProps(...args){
  return args.some(isNotNull)
}